import classNames from 'classnames'

import Icon, { EDHRECIconsType } from '@/components/Icon/Icon'

import styles from './StyledList.module.scss'

type Props = {
  groupIcon?: EDHRECIconsType
  items: Array<React.ReactNode | { icon?: EDHRECIconsType; item: React.ReactNode }>
}

const StyledList = ({ groupIcon, items }: Props) => (
  <table className={styles.table}>
    <tbody>
      {items.map((item, i) => {
        const curItem = item && typeof item === 'object' && 'item' in item ? item.item : item
        const curIcon =
          item && typeof item === 'object' && 'icon' in item && item.icon
            ? item.icon
            : groupIcon
              ? groupIcon
              : undefined
        const only = items.length === 1

        return (
          <tr key={i}>
            <td
              className={classNames(
                styles.leftCell,
                !only && i === 0 && styles.first,
                !only && i === items.length - 1 && styles.last,
                only && styles.only,
              )}
            >
              <div className={styles.circleDiv}>{curIcon ? <Icon icon={curIcon} /> : i + 1}</div>
            </td>
            <td className={styles.itemCell}>{curItem}</td>
          </tr>
        )
      })}
    </tbody>
  </table>
)

export default StyledList
